import {
    useQuery,
    useMutation,
    useQueryClient,
    QueryOptions,
    QueryResult,
    UseMutationResult,
    useSuspenseQuery,
} from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import type { AccountNumber } from '../generated-types';
import { getFavoriteAccount, saveFavoriteAccount } from '../services/favoriteAccountService';

export const FAVORITE_ACCOUNT_QUERY = ['favoriteAccount'];

export const useSuspendedFavoriteAccount = () =>
    useSuspenseQuery({
        queryKey: FAVORITE_ACCOUNT_QUERY,
        queryFn: getFavoriteAccount,
    });

const useFavoriteAccount = (
    options?: Partial<QueryOptions<AccountNumber | undefined>>,
): QueryResult<AccountNumber | undefined> =>
    useQuery({
        ...options,
        queryKey: FAVORITE_ACCOUNT_QUERY,
        queryFn: getFavoriteAccount,
    });

export const useFavoriteAccountMutate = (): UseMutationResult<void, RequestExceptionWithResponse, AccountNumber> => {
    const queryClient = useQueryClient();
    return useMutation<void, RequestExceptionWithResponse, AccountNumber>({
        mutationFn: saveFavoriteAccount,
        onSettled: () => queryClient.invalidateQueries({ queryKey: FAVORITE_ACCOUNT_QUERY }),
    });
};

export default useFavoriteAccount;
